<div id="repair-footer">
  <footer data-type="1x-footer" [attr.data-limited]="limited"></footer>
</div>
